
import { useState } from "react";
import { GameBoard } from "../GameBoard";
import { ErrorBoundary } from "./ErrorBoundary";
import { LoadingSpinner } from "@/components/ui/loading-spinner";
import type { Word, LogicRule } from "@/lib/game-utils";

interface GameContainerProps {
  words: Word[];
  logicRules: LogicRule[];
  targetOrder: Word[];
  targetRule: LogicRule;
  onComplete: (
    result: "perfect" | "almost" | "wrong",
    solveTime: number,
    selectedWords: Array<{ word: Word; order: number }>,
    selectedRule: LogicRule,
    rules: LogicRule[]
  ) => void;
  isReplay?: boolean;
  externalDataUrl?: string;
}

export function GameContainer(props: GameContainerProps) {
  const [isLoading, setIsLoading] = useState(false);
  console.log("GameContainer - Current props:", props);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  return (
    <ErrorBoundary>
      <GameBoard {...props} />
    </ErrorBoundary>
  );
}
